import React, { ChangeEventHandler } from 'react';

import ValidatorFormGroup from '../main/validator-form-group';

type Props<T extends string | number> = {
    values?: readonly T[];
    strings?: { [key in T]: string };
    label: string;
    name: string;
    disabled?: boolean;
    value: T;
    onChange: ChangeEventHandler<HTMLSelectElement>;
};

function ValidatorFormGroupDropDown<T extends string | number>(
    props: Readonly<Props<T>>
) {
    const selectedItem = props.value;
    const values = props.values ?? [];

    return (
        <ValidatorFormGroup label={props.label} hideErrorLabel>
            <select
                disabled={props.disabled}
                className={'form-control'}
                name={props.name}
                onChange={props.onChange}
                value={selectedItem}
                required
            >
                {!values.includes(selectedItem) && renderOption(selectedItem)}
                {values.map(renderOption)}
            </select>
        </ValidatorFormGroup>
    );

    function renderOption(v: T) {
        return (
            <option key={String(v)} value={v}>
                {props.strings?.[v] ?? v}
            </option>
        );
    }
}

export default ValidatorFormGroupDropDown;
